import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Date the legal text was last reviewed.
const LAST_UPDATED_ISO = '2026-04-24';

const ENTRY = {
  legalName:     'Mind Stack EOOD',
  address:       '10 Svetoslav Terter Street, 1124 Sofia, Bulgaria',
  email:         'hello@waitless.live',
  representedBy: 'Hristo Hristov',
  registration:  'EIK 208777526 — Bulgarian Commercial Register (Търговски регистър)',
  vatId:         'BG208777526',
};

const styles = {
  page: { minHeight: '100dvh', background: '#0F172A', color: '#F8FAFC', fontFamily: 'system-ui, -apple-system, sans-serif', padding: '3rem 1.5rem' },
  container: { maxWidth: 720, margin: '0 auto' },
  backLink: { color: '#60A5FA', textDecoration: 'none', fontSize: '0.9rem', display: 'inline-block', marginBottom: '2rem' },
  h1: { fontSize: '2rem', fontWeight: 800, color: '#F8FAFC', marginBottom: '0.5rem' },
  updated: { color: '#94A3B8', fontSize: '0.85rem', marginBottom: '2.5rem' },
  h2: { fontSize: '1.25rem', fontWeight: 700, color: '#F8FAFC', marginTop: '2rem', marginBottom: '0.75rem' },
  p: { color: '#CBD5E1', lineHeight: 1.7, marginBottom: '1rem', fontSize: '0.95rem' },
  dl: { display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '0.5rem 1.5rem', fontSize: '0.95rem', color: '#CBD5E1', marginBottom: '1.5rem', lineHeight: 1.6 },
  dt: { fontWeight: 600, color: '#F8FAFC' },
  dd: { margin: 0 },
  link: { color: '#60A5FA', textDecoration: 'none' },
};

export default function ImprintPage() {
  const { t, i18n } = useTranslation();
  const lastUpdated = new Date(LAST_UPDATED_ISO).toLocaleDateString(i18n.language, {
    year: 'numeric', month: 'long', day: 'numeric',
  });

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <Link to="/" style={styles.backLink}>{t('legal.back')}</Link>

        <h1 style={styles.h1}>{t('legal.imprint.title')}</h1>
        <p style={styles.updated}>{t('legal.lastUpdated', { date: lastUpdated })}</p>

        {/* English-only body, consistent with Privacy/Terms — a translated
            Impressum needs per-jurisdiction legal review. */}

        <p style={styles.p}>
          Information required under § 5 TMG (Germany), § 25 MedienG (Austria),
          and equivalent EU disclosure rules. Use the contact email below for
          any legal or press inquiry related to this website.
        </p>

        <h2 style={styles.h2}>Operator</h2>
        <dl style={styles.dl}>
          <dt style={styles.dt}>Legal name</dt>
          <dd style={styles.dd}>{ENTRY.legalName}</dd>
          <dt style={styles.dt}>Postal address</dt>
          <dd style={styles.dd}>{ENTRY.address}</dd>
          <dt style={styles.dt}>Email</dt>
          <dd style={styles.dd}><a href={`mailto:${ENTRY.email}`} style={styles.link}>{ENTRY.email}</a></dd>
          <dt style={styles.dt}>Represented by</dt>
          <dd style={styles.dd}>{ENTRY.representedBy}</dd>
        </dl>

        <h2 style={styles.h2}>Registration</h2>
        <dl style={styles.dl}>
          <dt style={styles.dt}>Commercial register</dt>
          <dd style={styles.dd}>{ENTRY.registration}</dd>
          <dt style={styles.dt}>VAT ID</dt>
          <dd style={styles.dd}>{ENTRY.vatId}</dd>
        </dl>

        <h2 style={styles.h2}>Responsibility for content</h2>
        <p style={styles.p}>
          Responsible for the content of this website under § 18 Abs. 2 MStV: {ENTRY.representedBy}.
        </p>

        <h2 style={styles.h2}>EU online dispute resolution</h2>
        <p style={styles.p}>
          The European Commission provides an online dispute resolution platform
          at <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style={styles.link}>ec.europa.eu/consumers/odr</a>.
          We are not obliged and not willing to participate in dispute resolution
          proceedings before a consumer arbitration board.
        </p>

        <h2 style={styles.h2}>Liability for links</h2>
        <p style={styles.p}>
          Our site may contain links to third-party websites whose content we do
          not control. We are not liable for external content; responsibility
          lies with the respective operators. Illegal content that comes to our
          attention will be removed without delay.
        </p>

        <h2 style={styles.h2}>Copyright</h2>
        <p style={styles.p}>
          Content and works on this site are subject to copyright law. Reproduction,
          adaptation, distribution, and any kind of use outside the limits of
          copyright require the written permission of the operator.
        </p>

        <p style={{ ...styles.p, marginTop: '2rem', borderTop: '1px solid #1E293B', paddingTop: '1.5rem' }}>
          See also our <Link to="/privacy" style={styles.link}>Privacy Policy</Link>,
          <> </><Link to="/terms" style={styles.link}>Terms of Service</Link>, and
          <> </><Link to="/legal/dpa" style={styles.link}>Data Processing Agreement</Link>.
        </p>
      </div>
    </div>
  );
}
